module.exports = __webpack_public_path__ + "img/img-31960d.png";